import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 group cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-heart-fill text-xl text-primary-500"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-900">
                暖暖爱视频
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              免费高清视频在线观看平台。无需注册、无需下载，随时随地畅享暖暖爱全集视频内容。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/aiqing-ju" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">爱情剧</Link></li>
              <li><Link to="/category/guzhuang-ju" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">古装剧</Link></li>
              <li><Link to="/category/xuanyi-ju" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">悬疑剧</Link></li>
            </ul>
          </div>

          {/* Articles */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">热门文章</h4>
            <ul className="space-y-2.5">
              <li><Link to="/article/nuannuanai-juqing-jiexi" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">暖暖爱剧情解析</Link></li>
              <li><Link to="/article/gaoqing-shipin-guankan-jiqiao" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">高清观看技巧</Link></li>
              <li><Link to="/article/guzhuang-ju-tuijian-2026" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">古装剧推荐</Link></li>
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">联系方式</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">常见问题</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 暖暖爱视频 nuannuanai.com. 保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer" rel="nofollow">使用条款</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}